export class drOption {
  value: string;
  label: string;

  constructor(value: string='', label: string='') {
    this.value = value;
    this.label = label;
  }
}

export class drOptionNote {
  value: string;
  label: string;
  note: string;

  constructor(value: string='', label: string='', note: string='') {
    this.value = value;
    this.label = label;
    this.note = note;
  }
}

export class drOptionId {
  id: number;
  label: string;

  constructor(id: number=0, label: string='') {
    this.id = id;
    this.label = label;
  }
}
